import { type PropsWithChildren } from "react";

import { useShellLayout } from "../context";
import { cx } from "../cx";

interface RootProps {
  hasTintedBackground?: boolean;
}

export const Root = ({
  children,
  hasTintedBackground = false,
}: Readonly<PropsWithChildren<RootProps>>) => {
  const { conversationPanelState } = useShellLayout();
  const hasInsetChrome = conversationPanelState !== "closed";

  return (
    <div
      data-testid="circle-ai-shell-inset-root"
      className={cx(
        "relative flex min-h-0 flex-1 flex-col overflow-hidden [transition:margin_280ms_cubic-bezier(0.77,0,0.175,1),border-radius_280ms_cubic-bezier(0.77,0,0.175,1),border-color_160ms_cubic-bezier(0.23,1,0.32,1),background-color_160ms_cubic-bezier(0.23,1,0.32,1)] motion-reduce:[transition:border-color_120ms_cubic-bezier(0.23,1,0.32,1),background-color_120ms_cubic-bezier(0.23,1,0.32,1)]",
        {
          "mx-4 my-3 rounded-lg border border-primary shadow-xs group-has-[[data-circle-ai-shell-dock]]/shell:ml-0":
            hasInsetChrome,
          "m-0 rounded-none border-0 shadow-none": !hasInsetChrome,
          "bg-secondary": hasInsetChrome && hasTintedBackground,
          "bg-primary dark:bg-secondary": !hasInsetChrome,
          "bg-primary": hasInsetChrome && !hasTintedBackground,
        },
      )}
    >
      {children}
    </div>
  );
};

Root.displayName = "CircleAIAppShell.Layout.Inset";
